const APP_VERSION = "3.0.0.0";

const Money = {
  CASH: "CASH",
  FPP: "FPP",
  POINTS: "POINTS"
}


const REPARTITION={
  TYPE_REPARTITIONS_POSITIONS						: 1,
	TYPE_REPARTITIONS_NBPLAYERS						: 2,
	TYPE_REPARTITIONS_ZONES							: 3,
	TYPE_REPARTITIONS_GROUP_STARTINGHAND			: 4,
	TYPE_REPARTITIONS_INVEST						: 5,
	TYPE_REPARTITIONS_CONTEXT						: 6,
	TYPE_REPARTITIONS_FINALHANDS					: 7,
	TYPE_REPARTITIONS_ACTION_PREFLOP				: 8,
	TYPE_REPARTITIONS_ACTION_FLOP					: 10,
	TYPE_REPARTITIONS_ACTION_TURN					: 12,
	TYPE_REPARTITIONS_ACTION_RIVER					: 14,
	TYPE_REPARTITIONS_AMOUNTS						: 16,
	TYPE_REPARTITIONS_SINGLE_STARTINGHANDS			: 19,

	TYPE_REPARTITIONS_LIMITS						: 20,
	TYPE_REPARTITIONS_NB_SEATS						: 21,
	TYPE_REPARTITIONS_TOURNAMENT_STRUCTURE			: 22,
	type_REPARTITIONS_TOURNAMENT_FINISH				: 25,
	TYPE_REPARTITIONS_TOURNAMENT_NBPLAYERS			: 26,
	TYPE_REPARTITIONS_VARIANT						: 27,
	TYPE_REPARTITIONS_MONEY							: 28,
	TYPE_REPARTITIONS_PLAYERS						: 29,
	TYPE_REPARTITIONS_SCHEDULE						: 30,
	TYPE_REPARTITIONS_HOURS							: 31,
	TYPE_REPARTITIONS_DAY_OF_WEEK					: 32,
	TYPE_REPARTITIONS_PERCENTAGE					: 33,
	TYPE_REPARTITIONS_FLOP_HANDS					: 34,
	TYPE_REPARTITIONS_TURN_HANDS					: 35,
	TYPE_REPARTITIONS_CATEGORIES					: 36,
	TYPE_REPARTITIONS_RESULT						: 37,
	TYPE_REPARTITIONS_PRIZEPOOL						: 38,

	TYPE_REPARTITIONS_DAYS							: -1,
	TYPE_REPARTITIONS_WEEK							: -2,
	TYPE_REPARTITIONS_MONTH							: -3,
	TYPE_REPARTITIONS_YEAR							: -4

}
export { APP_VERSION, Money, REPARTITION}
